import api from './axios'

export default {
  getAllUsers () {
    return api().get('/api/users/getAllUsers')
  }
}
